module.exports = __webpack_public_path__ + "img/angry.799544d1.png";